<template>
    <SlideWhite>
        <div
            class="relative h-full flex items-end justify-center bg-no-repeat bg-cover bg-center"
            :style="{ backgroundImage: `url(${require('@/assets/images/deckblatt_hintergrundbild.jpg')})` }"
        >
            <div class="absolute inset-0 z-10 bg-black/20"></div>

            <div class="absolute bottom-0 z-20">
                <div class="flex space-x-[40px] mb-[222px] mx-[417px]">
                    <div class="bg-primary-500 w-[280px] h-[280px] flex-shrink-0 flex items-center justify-center">
                        <Logo class="w-[214px]" />
                    </div>
                    <div class="text-white flex flex-col justify-center items-center">
                        <img src="@/assets/images/Eigentumswohnungen_multilingual_01.png" alt="Eigentumswohnungen_multilingual_01.png" class="h-auto">
                    </div>
                </div>
            </div>
        </div>
    </SlideWhite>
</template>

<script>
import Logo from '../Partials/Logo.vue'
import SlideWhite from '../Layouts/SlideWhite.vue'

export default {
    props: {

        activeSlide: {
            type: Boolean,
            default: false
        },
    },

    mounted() {},

    components: {
        SlideWhite,
        Logo,
    }
}
</script>